import { render, staticRenderFns } from "./summarizeText.vue?vue&type=template&id=22f0c260&scoped=true&"
import script from "./summarizeText.vue?vue&type=script&lang=js&"
export * from "./summarizeText.vue?vue&type=script&lang=js&"
import style0 from "./summarizeText.vue?vue&type=style&index=0&id=22f0c260&scoped=true&lang=css&"
import style1 from "./summarizeText.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f0c260",
  null
  
)

export default component.exports